import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'


export const getBookings = createAsyncThunk('UpcomingBooking/getBookings', async (params) => {
     
    const response = await axios.post(' https://api.zasway.com:8443/Booking/GetTableSummaryBookingDriverApp', params, {mode:'cors'})
     
    return response.data
})
export const getSummary = createAsyncThunk('UpcomingBooking/getSummary', async (params) => {
     
  const response = await axios.post(' https://api.zasway.com:8443/Driver/GetDriverPaymentSummary', params, {mode:'cors'})
  
  return response.data
})
export const getpaymentsummarydriver = createAsyncThunk('UpcomingBooking/getpaymentsummarydriver', async (params) => {
       
  const response = await axios.post(' https://api.zasway.com:8443/BookingInvoice/GetGenerateDocumentDriverPaymentForDriverApp', params, {mode:'cors'})
  
  return response.data
})
export const getDriverDetail = createAsyncThunk('DriverStatusDashboard/getDriverDetail', async (GetDriver) => {
    
  const response = await axios.post(' https://api.zasway.com:8443/Driver/GetTableSummaryDriver', GetDriver, { mode: 'cors' })

  return response.data
})
export const getBookingsHistory = createAsyncThunk('BookingHistory/getBookingsHistory', async (params) => {
   
  const response = await axios.post(' https://api.zasway.com:8443/Booking/GetTableSummaryBookingDriverHistory', params, {mode:'cors'})
   
  return response.data
})
export const getBookingsPerWeek = createAsyncThunk('DriverDashboard/getBookingsPerWeek', async (params) => {
        
  const response = await axios.post(' https://api.zasway.com:8443/Booking/GetDriverDashboardDetails', params, {mode:'cors'})
 
  return response.data

})
export const getBookingsThisMonth = createAsyncThunk('DriverDashboard/getBookingsPerWeek', async (params) => {
        
  const response = await axios.post(' https://api.zasway.com:8443/Booking/GetTableSummaryBookingDriverAppPerWeek', params, {mode:'cors'})
   
  return response.data

})
export const getBookingsToday = createAsyncThunk('DriverDashboard/getBookingsToday', async (params) => {
    
  const response = await axios.post(' https://api.zasway.com:8443/Booking/GetTableSummaryBookingDriverAppPerWeek', params, {mode:'cors'})
 
  return response.data
  
})
export const getBookingHistorydetails = createAsyncThunk('UpcomingBooking/getBookingdetails', async (params) => {
const response = await axios.post(' https://api.zasway.com:8443/Booking/GetBooking', params, {mode:'cors'})

return response.data
})

export const getBookingdetails = createAsyncThunk('UpcomingBooking/getBookingdetails', async (params) => {
    
  const response = await axios.post(' https://api.zasway.com:8443/Booking/GetBooking', params, {mode:'cors'})

  return response.data
})
export const confirmBooking = createAsyncThunk('UpcomingBooking/confirmBooking', async (params) => {
     
    const response = await axios.post(' https://api.zasway.com:8443/Driver/ConfirmBooking', params, {mode:'cors'})
  
    return response.data
  })
 
  export const startRideBooking = createAsyncThunk('UpcomingBooking/startRideBooking ', async (params) => {
        
    const response = await axios.post(' https://api.zasway.com:8443/Driver/UpdateBookingStatusForJourney', params, { mode: 'cors' })
      
    return response.data
})
export const AddRideLocationLog = createAsyncThunk('UpcomingBooking/AddRideLocationLog ', async (params) => {
  const response = await axios.post(' https://api.zasway.com:8443/Booking/AddLiveLocationLog', params, { mode: 'cors' })
    
  return response.data
})
export const CheckLocation = createAsyncThunk('UpcomingBooking/CheckLocation', async (params) => {
   
  const response = await axios.post(' https://api.zasway.com:8443/Booking/GetBookingLiveLocationList', params, {mode:'cors'})
 
  return response.data
})
  export const rejectBooking = createAsyncThunk('UpcomingBooking/rejectBooking', async (params) => {
    
    const response = await axios.post(' https://api.zasway.com:8443/Driver/RejectBooking', params, {mode:'cors'})
  
    return response.data
  })
  
  export const updateBookingStatusOnRoute = createAsyncThunk('UpcomingBooking/updateBookingStatusOnRoute ', async (params) => {
        
    const response = await axios.post(' https://api.zasway.com:8443/Driver/UpdateBookingStatusForJourney', params, { mode: 'cors' })
      
    return response.data
})

export const GetDrNotifications = createAsyncThunk('UpcomingBooking/GetBookingEditNotif ', async (params) => {
        
  const response = await axios.post(' https://api.zasway.com:8443/Driver/GetDriverNotifications', params, { mode: 'cors' })
    
  return response.data
   
})
export const setIsNotified = createAsyncThunk('UpcomingBooking/GetBookingEditNotif ', async (params) => {
  
const response = await axios.post(' https://api.zasway.com:8443/Driver/UpdateIsNotified', params, { mode: 'cors' })

return response.data

})


export const DriverDashboardSlice = createSlice({
    name: 'DriverDashboard',
    initialState: {
        data: [],
        NotificationData: [],
        historydata: []
  
    },
    reducers: {},
    extraReducers: builder => {
        builder
           
        
           .addCase(getBookingsHistory.fulfilled, (state, action) => {
              state.historydata = action.payload
            })
            .addCase(getBookings.fulfilled, (state, action) => {
                state.data = action.payload
            })
            .addCase(GetDrNotifications.fulfilled, (state, action) => {

              state.NotificationData = action.payload
            })
          //   .addCase(GetBookingEditNotif.fulfilled, (state, action) => {
          //        
          //     state.BookEdit = action.payload.list
          //     state.lastrec = action.payload.lastrecord.bookingID
          //   })
          // .addCase(setBookingEd.fulfilled, (state) => {
          //    
          //   state.EditPrevLen = state.BookEdit.length
          // })
            
    }
})
export default DriverDashboardSlice.reducer